var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChannelSettingsNotificationsActiveIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.746,
    height: 16.746,
    viewBox: "0 0 16.746 16.746",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "notifications-active-svgrepo-com",
    d: "M10.623,5.118a4.235,4.235,0,0,1,4.235,4.235v1.9a1.694,1.694,0,0,0,.428,1.125l1.081,1.216a1.27,1.27,0,0,1-.95,2.115H5.829a1.27,1.27,0,0,1-.95-2.115l1.08-1.216a1.694,1.694,0,0,0,.428-1.125v-1.9A4.235,4.235,0,0,1,10.623,5.118Zm0,0V3M3,9.776A7.616,7.616,0,0,1,6.388,3.437M18.246,9.776a7.616,7.616,0,0,0-3.388-6.339M9.776,18.246H11.47",
    transform: "translate(-2.25 -2.25)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelSettingsNotificationsActiveIcon);
export default __webpack_public_path__ + "static/media/channel-settings-notifications-active-icon.8d4d173aa1e51ddc8144d3282e60cef4.svg";
export { ForwardRef as ReactComponent };